export const deviceVerificationErrorHandler = function (response, vue) {
    if (response.status === 401) {
        switch (response.body.msg) {
            case 'wrong_password':
                vue.$showAlertMessage(vue.$t('login.wrong_password'));
                break;
            case 'locked_account_error':
                vue.$showAlertMessage(vue.$t('login.locked_account_error'));
                break;
            default:
                vue.$showAlertMessage(vue.$t('device_verification.incorrect_code'));
        }
    } else if (typeof response.body === 'object' && 'msg' in response.body) {
        vue.$showAlertMessage(response.body.msg);
    } else {
        vue.$showAlertMessage(vue.$t('error_messages.unknown'));
    }
};
